import { ContextApp } from '../contexts/ContextApp';
import GraphqlService from '../services/graphql/GraphqlService';
import { useContext, useEffect, useMemo, useState } from "react";


export const useFieldVisibilities = () => {

  const { selectedTenantId } = useContext(ContextApp);
  const { Query, customRequest } = GraphqlService();
  const [visibilities, setVisibilities] = useState<Record<string, boolean | undefined>>({});
  const fieldNames = useMemo(() => ['product_code', 'cost_center'], []);

  useEffect(() => {
    if (!selectedTenantId || fieldNames.length === 0) return;

    let isMounted = true;

    const fetchVisibilities = async () => {
      const visibilityResults: Record<string, boolean | undefined> = {};

      for (const field of fieldNames) {
        try {
          const result = await customRequest({
            query: Query.getDecisionItemConfigurations,
            variables: {
              filter: {
                tenant_id: selectedTenantId,
                field_name: field,
              },
            },
          });

          if (isMounted) {
            visibilityResults[field] = result?.length > 0 ? result[0].visible : undefined;
          }
        } catch (err) {
          console.error(`Error fetching visibility for ${field}:`, err);
          if (isMounted) {
            visibilityResults[field] = undefined;
          }
        }
      }

      if (isMounted) {
        setVisibilities(prev => ({...prev, ...visibilityResults}));
      }
    };

    fetchVisibilities();

    return () => {
      isMounted = false;
    };
  }, [selectedTenantId, fieldNames, setVisibilities]);

  return visibilities;
};